import React, { useEffect } from 'react';
import { useAuth } from './auth_context';
import { useUser } from './user_context';
import { userData } from '../data/data_users';

const UserInitializer = ({ children }) => {
  const { token, isAuthReady } = useAuth();
  const { user, setUser, setIsLoading } = useUser();

  useEffect(() => {
    const fetchUserInfo = async () => {
      // Only fetch user info if we have a token, auth is ready, and we don't already have user data
      if (token && isAuthReady && !user) {
        try {
          setIsLoading(true);
          const response = await userData.getUserInfo();
          // Extract user data from the response structure
          if (response && response.success && response.user) {
            setUser(response.user);
          } else {
            console.error('Invalid user response structure:', response);
          }
        } catch (error) {
          console.error('Error fetching user info on app load:', error);
          // Don't block the app if user info fetch fails
        } finally {
          setIsLoading(false);
        }
      }
    };

    fetchUserInfo();
  }, [token, isAuthReady, user, setUser, setIsLoading]);

  return children;
};

export default UserInitializer; 